
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fSItB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $348b5da81993bd17$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $348b5da81993bd17$export$2e2bcd8739ae039 = {
    'extension.charts.aggregateData': 'Agregovat data',
    'extension.charts.aggregateDataDescription': "V\xa0p\u0159\xedpad\u011B, \u017Ee m\xe1 v\xedce \u0159\xe1dk\u016F stejnou hodnotu, m\u016F\u017Eete tyto hodnoty zkombinovat do jedin\xe9ho datov\xe9ho bodu.",
    'extension.charts.category': 'Kategorie',
    'extension.charts.customizeTab': "P\u0159izp\u016Fsobit",
    'extension.charts.dataMissing.details': "Zdrojovou tabulku tohoto grafu se na str\xe1nce nepoda\u0159ilo naj\xedt.",
    'extension.charts.dataMissing.title': "\u017D\xe1dn\xe1 data k\xa0zobrazen\xed",
    'extension.charts.dataTab': 'Data',
    'extension.charts.defaultColumnName': 'Sloupec {0}',
    'extension.charts.defaultTitle': "Graf bez n\xe1zvu",
    'extension.charts.defaultYLabel': "Osa bez n\xe1zvu",
    'extension.charts.extensionTitle': 'Graf',
    'extension.charts.height': "V\xfd\u0161ka oblasti vykreslen\xed",
    'extension.charts.height.large': "Vy\u0161\u0161\xed",
    'extension.charts.height.medium': "V\xfdchoz\xed",
    'extension.charts.height.small': "Ni\u017E\u0161\xed",
    'extension.charts.horizontal.orientation.label': "Horizont\xe1ln\xed",
    'extension.charts.insert.tooltip': "Vlo\u017Eit graf",
    'extension.charts.legend': 'Legenda',
    'extension.charts.legend.auto': 'Automaticky',
    'extension.charts.legend.bottom': 'Dole',
    'extension.charts.legend.left': 'Vlevo',
    'extension.charts.legend.position': "Um\xedst\u011Bn\xed legendy",
    'extension.charts.legend.right': 'Vpravo',
    'extension.charts.legend.show': 'Zobrazit legendu',
    'extension.charts.legend.top': "Naho\u0159e",
    'extension.charts.options.label': "Mo\u017Enosti grafu",
    'extension.charts.options.tooltip': "Zm\u011Bnit mo\u017Enosti grafu",
    'extension.charts.orientation.label': 'Orientace',
    'extension.charts.seriesNames': "Datov\xe9 \u0159ady",
    'extension.charts.showPoints': "Zobrazit datov\xe9 body",
    'extension.charts.smoothLines': "Vyhlazen\xe9 \u010D\xe1ry",
    'extension.charts.style': 'Styl',
    'extension.charts.title': "N\xe1zev",
    'extension.charts.type.bar': "Pruhov\xfd",
    'extension.charts.type.fieldDescription': 'Typ grafu',
    'extension.charts.type.line': "Spojnicov\xfd",
    'extension.charts.type.pie': "V\xfdse\u010Dov\xfd",
    'extension.charts.userTitle': "N\xe1zev",
    'extension.charts.vertical.orientation.label': "Vertik\xe1ln\xed",
    'extension.charts.xAxis': 'Osa X',
    'extension.charts.xLabel': 'Popisek osy X',
    'extension.charts.yLabel': 'Popisek osy Y'
};

});


//# sourceMappingURL=cs.cae1cbe3.js.map
